import { axiosCall } from "./apiRequest";
import { baseUrl } from "./helper";

export const reissueCoupons = async (userData) => {
  try {
    const token = localStorage.getItem("token")
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(baseUrl + "order/orders/cancelled-with-discount", "post", userData, header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const regenerateCoupon = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(baseUrl + `order/insert/coupon/crm-ticket`, "post", userData, header
    );
    return response;
  } catch (error) {
    throw error;
  }
}